import { DateOrNull } from "./resource.utils.types";

export enum UserRole {
  admin = "admin",
  sportClub = "sportClub",
  store = "store",
  agent = "agent",
  gym = "gym",
  academy = "academy",
  coach = "coach",
  entertainment = "entertainment",
  unknown = "unknown",
}

export interface User {
  id: string | undefined;
  email: string | null;
  emailVerified: boolean;
  displayName: string | null;
  role: UserRole;
  creationTime: DateOrNull;
  loading: boolean;
  reservationLastSeenAt: DateOrNull;
  requestsLastSeenAt: DateOrNull;
  ordersLastSeenAt: DateOrNull;
  status: string | null;
  defaultSlotTime: number;
  sportTypeIds: any;
  path: string | null;
  webviewFcmToken: string | null;
}
